export enum DriverEnum {
  ALL = 'ALL',
  FULLTIME = 'FULLTIME',
  FREELANCER = 'FREELANCER',
}
